// utils/sarSiteColors.js
import * as THREE from 'three';

// Order determines color assignment - keep in sync with registry.json.
// Appending new sites at the end preserves existing colors; inserting
// in the middle reshuffles everything after it.
const SITE_IDS_IN_ORDER = [
  'malacca_1', 'malacca_2', 'hormuz', 'bab_el_mandeb', 'suez', 'panama',
  'bosphorus', 'gibraltar', 'dover', 'danish_straits', 'taiwan_strait',
  'korea_strait', 'scs_lanes', 'persian_gulf', 'houston', 'shanghai',
  'rotterdam', 'singapore_port', 'la_long_beach', 'ny_nj', 'puget_sound',
];

// Golden-angle hue spacing maximizes perceptual distance between
// ADJACENT indices - important here since malacca_1/malacca_2 sit
// next to each other in the list AND geographically, so they need to
// look clearly different, not just "different enough on paper."
const GOLDEN_ANGLE = 137.508;

function hslColor(hue, s, l) {
  const color = new THREE.Color();
  color.setHSL(((hue % 360) + 360) % 360 / 360, s, l);
  return color;
}

export const SITE_COLOR_MAP = SITE_IDS_IN_ORDER.reduce((acc, id, i) => {
  acc[id] = hslColor(i * GOLDEN_ANGLE, 0.85, 0.55);
  return acc;
}, {});

const FALLBACK_COLOR = new THREE.Color('#9ca3af');

// SITE_COLOR_MAP.rotterdam = new THREE.Color('#39ff14');

export function colorForSite(siteId) {
  return SITE_COLOR_MAP[siteId] || FALLBACK_COLOR;
}

export function siteColorList() {
  return SITE_IDS_IN_ORDER.map(id => ({ id, color: SITE_COLOR_MAP[id] }));
}